// errorCode the API returns when a contact's email belongs to an existing account that the consultant has not
// confirmed yet (backend: BeeAddressBookExistingAccountException)
export const EXISTING_ACCOUNT_ERROR_CODE = 'BeeAddressBookExistingAccountException' as const
